import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductServiceType } from './models/productServiceType.enum';

@Injectable({
  providedIn: 'root'
})
export class ProductsAndServicesTabsNewService {

  showProductServiceType: BehaviorSubject<ProductServiceType> = new BehaviorSubject<ProductServiceType>(null);
  tabNumber: BehaviorSubject<ProductServiceType> = new BehaviorSubject<ProductServiceType>(null);
  EditType:number=0;
  /** Active=1, Archived=2, Deleted=3 — preserved across create/edit so return stays on same list. */
  lastListStatusType: number = 1;

  constructor() {
  }

  setTab(event: number) {
    this.tabNumber.next(event);
  }

  getTab() {
    return this.tabNumber.asObservable();
  }
}
